import { client } from "./api/client";
import { buildEventTicketsEditURL, buildEventTicketsURL } from "./api/urlBuilder";

export type EventTicket = Record<string, any>;

export async function getEventTickets(eventId: string, includeFees: boolean, token: string) {
    const response = await client.get(buildEventTicketsURL({ eventId, includeFees }), { token });
    return response.data;
}

export async function createEventTickets(eventId: string, tickets: EventTicket[], token: string) {
    const response = await client.post(buildEventTicketsURL({}), { eventId, tickets }, { token });
    return response.data;
}

export async function editEventTickets(eventId: string, tickets: EventTicket[], token: string) {
    const response = await client.post(buildEventTicketsEditURL("edit-ticket"), { eventId, tickets }, { token });
    return response.data;
}

export async function deleteEventTickets(eventId: string, tickets: EventTicket[], token: string) {
    const response = await client.post(buildEventTicketsEditURL("delete-ticket"), { eventId, tickets }, { token });
    return response.data;
}
